module.exports = __webpack_public_path__ + "img/lmv_fr-LU.bec43389.svg";